import { NAME } from './constants'

export const getQuestionList = (state) => state[NAME].questionList
export const getValuesList = (state) => state[NAME].valuesList
